<template>
    <div>
        <Modal v-model="$parent.usersListDialog" :mask-closable="false" fullscreen footer-hide>
            <div slot="header"><span style="font-weight: 500; font-size: 18px;padding: 0 0 0 10px">Users ({{users.length}})</span>
              <Button @click="$parent.usersListDialog=false" icon="md-close" shape="circle" style="float: right; font-size: 20px;margin:-8px 0 0 0"></Button>
              <Button @click="openAddUserDrawer" type="primary" style="float: right;margin:-8px 30px 0 0">ADD USER</Button>
            </div>
            <div>
                <Table :columns="headers" :data="users" v-if="$parent.usersListDialog">
                    <template slot-scope="{ row }" slot="role">
                        {{roleObj[row.role]}}
                    </template>
                  <template slot-scope="{ row }" slot="city">
                        {{row.userCities.map(u => u.city).join(', ') || '-'}}
                    </template>
                  <template slot-scope="{ row }" slot="status">
                    <i-switch v-model="row.isActive" @on-change="onChangeStatus(row)" :style="row.isActive?'background: green':'background: red'"/>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <i class="fas fa-lock lock-icon" title="Change Password" @click="openChangePassword(row)"></i>
                        <Icon type="md-create" title="Edit User" style="cursor: pointer" @click="openEditUserDrawer(row)"></Icon>
                    </template>
                </Table>
            </div>
            <div slot="footer">
              <Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.usersListDialog=false">CLOSE</Button>
            </div>
        </Modal>

        <add-user-drawer></add-user-drawer>
        <changePassword :dialog.sync="changePasswordDialog" :userId.sync="userId"/>
    </div>
</template>

<script>
import {SUBSCRIBE_USERS} from '../../graphql/subscription/users'
import {GET_USER_ROLES} from '../../graphql/queries/users'
import AddUserDrawer from '../../components/AddUserDrawer'
import {convertArrToObj} from '../../Constants/Constant'
import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
import ChangePassword from "./ChangePassword";
    export default {
        apollo: {
          $subscribe: {
            users: {
              query: SUBSCRIBE_USERS,
              result({data}) { this.users = data.users }
            }
          },
          roles: {
            query: GET_USER_ROLES,
            result({data}) { this.rolesArr = data.roles;
                             this.roleObj = convertArrToObj(data.roles, 'id', 'name') }
          }
        },
        name: "User",
        components: {ChangePassword, AddUserDrawer},
        data: function(){
            return{
                users: [],
                rolesArr: [],
                headers: [
                    {title: 'Name', key: 'name', width:200},
                    {title: 'Mobile', key: 'mobile',  width:130},
                    {title: 'Email', key: 'email',  width:240},
                    {title: 'Role', slot: 'role',  width:132},
                    {title: 'Cities', slot: 'city'},
                    {title: 'Status', slot: 'status',  width:120},
                    {title: 'Action', slot: 'action',  width:100},
                ],
                addUserDrawer: false,
                roleObj: {},
                userData: '',
                changePasswordDialog: false,
                userId: null
            }
        },
        methods: {
          openAddUserDrawer: function(){
            this.userData = '';
            this.addUserDrawer = true;
          },
          openEditUserDrawer: function(row){
            this.userData = row;
            this.addUserDrawer = true;
          },
          openChangePassword(row){
            this.userId = row.id;
            this.changePasswordDialog = true
          },
          onChangeStatus(row){
            this.$Modal.confirm({
              title: 'Confirmation',
              content: '<p>Are You sure want to change status of User ?</p>',
              loading: true,
              onOk: () => {
                let obj = {isActive: row.isActive}
                this.updateRecord(row.id, obj, 'users', this.$Modal)
              },
              onCancel: () => {
                row.isActive = !row.isActive
              }
            });
          },
          async updateRecord(id, obj, table, callback){
            let response = await this.$apollo.mutate({
              mutation: generate_UPDATE_ORDER_DATA(table),
              variables: { id: id, obj: obj}
            })
            if(response.data){
              this.$Message.success('User updated successfully!')
              callback.remove();
            }
          },
        }
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    .lock-icon{
      cursor: pointer;
      margin-right: 20px;
    }
    /* /deep/ .ivu-table td {
        border-bottom: 0px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    } */
</style>
